import Splide from '@splidejs/splide';
import SimpleBar from "simplebar";
import { uaCheck, mq } from "./modules/utils";
import '@splidejs/splide/dist/css/splide.min.css';

uaCheck();
mq();

function accArea() {
  $(".acc-btn").on("click", function () {
    $(this).toggleClass("active");
    $(this).next().slideToggle();
  });
  $("#event .acc-btn").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).children().html("CLOSE");
    } else {
      $(this).children().html("MORE");
    }
  });
}

function smoothScroll() {
  $('a[href^="#"]').on("click", function () {
    let speed = 500;
    let href = $(this).attr("href");
    let target = $(href === "#" || href === "" ? "html" : href);
    let position = target.offset().top;

    $("body,html").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
}

function scrollBar() {
  const newslist = document.getElementById("newslist");
  if (newslist) {
    const simpleBarInstance = new SimpleBar(newslist, {
      autoHide: false,
    });
  }
}

function toggleBtn() {
  if (mq("sp")) {
    $(".toggle-btn").on("click", function () {
      $(this).toggleClass("active");
      $(this).next().fadeToggle();
    });
    $("nav a").on("click", function () {
      $(this).parents("nav").fadeOut();
      $(".toggle-btn").removeClass("active");
    });
  }
}

function modal() {
  $(".modal-btn").on("click", function () {
    let id = $(this).attr("id"); // クリックされたボタンのIDを取得
    let modalId = `#modal-area${id.slice(-2)}`; // 対応するモーダルエリアのIDを作成
    $(modalId).fadeIn(); // 対応するモーダルエリアを表示
  });

  $(".modal-area .close-btn, .modal-area").on("click", function () {
    $(this).closest(".modal-area").fadeOut(); // クリックされたモーダルエリアを非表示
  });

  // モーダル内のコンテンツ領域をクリックしても閉じないようにする
  $(".modal-content").on("click", (e) => {
    e.stopPropagation();
  });
}

function splideFnc() {
  const splideEl = document.querySelector('.splide');
  if (!splideEl) return;

  const splide = new Splide(splideEl, {
    type: 'loop',
    perPage: 1,
    arrows: false,
    autoplay: true,
    speed: 1000,
    interval: 3000,
  });

  splide.mount();
}

function tabArea() {
  const allTabItems = document.querySelectorAll('.tab-item');
  const allTabContents = document.querySelectorAll('.tab-content');

  allTabItems.forEach(tab => {
    tab.addEventListener('click', function () {
      const targetTabId = this.dataset.tab;

      // 全タブのアクティブ状態を更新
      allTabItems.forEach(t => {
        t.classList.toggle('is-active', t.dataset.tab === targetTabId);
      });

      // 対応するコンテンツを表示
      allTabContents.forEach(content => {
        content.classList.toggle('is-active', content.id === targetTabId);
      });

      // 押したタブだけ中央寄せ（上下両方 scrollIntoView すると不自然なので1つだけ）
      this.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });
  });
}

function storelistJson() {
  const handleTabClick = (event) => {
    const targetTabId = event.currentTarget.dataset.tab;

    const allTabItems = document.querySelectorAll('.tab-item');
    const allTabContents = document.querySelectorAll('.tab-content');

    allTabItems.forEach((t) => {
      t.classList.toggle('is-active', t.dataset.tab === targetTabId);
    });

    allTabContents.forEach((content) => {
      content.classList.toggle('is-active', content.id === targetTabId);
    });

    event.currentTarget.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest',
    });
  };

  const setupTabSwitching = () => {
    const allTabItems = document.querySelectorAll('.tab-item');
    allTabItems.forEach((tab) => {
      tab.addEventListener('click', handleTabClick);
    });
  };

  const renderShops = (data) => {
    const tabListTop = document.querySelector('.tab-list.top');
    const tabListBottom = document.querySelector('.tab-list.bottom');
    const tabContents = document.querySelector('.tab-contents');

    let isFirst = true;

    Object.entries(data).forEach(([district, shops]) => {
      const tabId = `tab-${district}`;

      [tabListTop, tabListBottom].forEach((tabList) => {
        const li = document.createElement('li');
        li.className = 'tab-item';
        if (isFirst) li.classList.add('is-active');
        li.dataset.tab = tabId;
        li.textContent = district;
        tabList.appendChild(li);
      });

      const contentDiv = document.createElement('div');
      contentDiv.className = 'tab-content';
      if (isFirst) contentDiv.classList.add('is-active');
      contentDiv.id = tabId;

      shops.forEach((shop) => {
        const box = document.createElement('div');
        box.className = 'shop-box';
        box.innerHTML = `
          <p class="shop-area">${shop.area}</p>
          <h4 class="shop-name">${shop.name}</h4>
          <p class="shop-place">${shop.place}</p>
        `;
        contentDiv.appendChild(box);
      });

      tabContents.appendChild(contentDiv);
      isFirst = false;
    });
  };

  fetch('../assets/json/storelist.json')
    .then((response) => response.json())
    .then((data) => {
      renderShops(data);
      setupTabSwitching();
    });
}

window.addEventListener("load", () => {
  accArea();
  smoothScroll();
  scrollBar();
  toggleBtn();
  modal();
  splideFnc();
  tabArea();
  storelistJson();
});
